export default function Squircle({ size = "card", className = "" }) {
	return (
		<div className={`squircle squircle-${size} ${className}`}>
			<svg className="corner tl" viewBox="0 0 20 20">
				<path d="M0,20C0,4.7,4.7,0,20,0H0v20Z" vectorEffect="non-scaling-stroke"/>
			</svg>
			<svg className="corner tr" viewBox="0 0 20 20">
				<path d="M0,20C0,4.7,4.7,0,20,0H0v20Z" vectorEffect="non-scaling-stroke"/>
			</svg>
			<svg className="corner bl" viewBox="0 0 20 20">
				<path d="M0,20C0,4.7,4.7,0,20,0H0v20Z" vectorEffect="non-scaling-stroke"/>
			</svg>
			<svg className="corner br" viewBox="0 0 20 20">
				<path d="M0,20C0,4.7,4.7,0,20,0H0v20Z" vectorEffect="non-scaling-stroke"/>
			</svg>
		</div>
	);
}